// About 페이지 번역 - 성동중앙교회 교회소개 페이지
export default {
  intro: {
    title: '환영합니다',
    churchName: '성동중앙교회',
    description1: '성동중앙교회를 방문하신 여러분들을 진심으로 환영합니다.',
    description2: '우리 성동중앙교회는 예수 그리스도를 우리의 꿈이요 소망으로 삼는 교회입니다.',
    description3: '하나님 말씀에 절대적 권위를 두며 신앙의 표준으로 삼는 교회입니다.',
    description4: '하나님께서 우리를 통해 더 큰 일을 이루어 가는 교회입니다. 이 아름다운 공동체에 여러분들을 초대합니다.',
    missionTitle: '교회 비전',
    missionText: '우리 교회는 하나님 중심의 교회로서 가족 공동체를 이루고 성숙한 그리스도인이 되며 하나님께 바르게 예배하고 다시 오실 주님을 맞이하도록 준비하는 교회입니다.'
  },
  leadership: {
    title: '섬기는',
    titleHighlight: '사람들',
    description: '성동중앙교회를 섬기는 목사님들과 장로님들을 소개합니다.',
    pastorSection: '목사',
    elderSection: '장로',
    activeElder: '시무장로',
    emeritusElder: '은퇴장로'
  },
  staff: {
    title: '협동',
    titleHighlight: '목사',
    description: '함께 사역하는 협동목사님들입니다.',
    note: '협동목사 정보는 준비 중입니다.'
  },
  location: {
    title: '방문',
    titleHighlight: '안내',
    description: '성동중앙교회를 방문해 주세요.',
    addressTitle: '주소',
    parkingTitle: '주차',
    parkingDescription: '1층과 지하에 주차가 가능합니다.',
    transportTitle: '찾아오시는 길',
    subwayLabel: '지하철:',
    busLabel: '버스:'
  },
  schedule: {
    title: '예배',
    titleHighlight: '시간',
    description: '성동중앙교회 예배 시간 안내입니다.',
    tableService: '예배',
    tableTime: '시간',
    tableLocation: '장소',
    note: '예배 시간은 변경될 수 있습니다. 자세한 사항은 교회 사무실로 문의해 주세요.'
  }
};
